import axios from "axios";

export default {
  strict: true,
  namespaced: true,
  state: {
    hasBusinessProfile: false,
    hasTaxRates: false,
    hasLocation: false,
    hasSubscription: false,
    hasProductsAndPlans: false,
    hasBrandColorsAndLogo: false,
    hasMerchantProcessing: false,
  },
  getters: {
    hasBusinessProfile: (state) => state.hasBusinessProfile,
    hasTaxRates: (state) => state.hasTaxRates,
    hasLocation: (state) => state.hasLocation,
    hasSubscription: (state) => state.hasSubscription,
    hasProductsAndPlans: (state) => state.hasProductsAndPlans,
    hasBrandColorsAndLogo: (state) => state.hasBrandColorsAndLogo,
    hasMerchantProcessing: (state) => state.hasMerchantProcessing,
  },
  mutations: {
    setBusinessProfile(state, payload) {
      state.hasBusinessProfile = payload;
    },
    setTaxRates(state, payload) {
      state.hasTaxRates = payload;
    },
    setLocation(state, payload) {
      state.hasLocation = payload;
    },
    setSubscription(state, payload) {
      state.hasSubscription = payload;
    },
    setProductsAndPlans(state, payload) {
      state.hasProductsAndPlans = payload;
    },
    setBrandColorsAndLogo(state, payload) {
      state.hasBrandColorsAndLogo = payload;
    },
    setMerchantProcessing(state, payload) {
      state.hasMerchantProcessing = payload;
    },
  },
  actions: {
    init: async (context) => {
      // Return if not a business
      if (!context.rootGetters["organization/isOrganizationBusiness"]) {
        return;
      }

      // Return early if Organization is active
      const organization = context.rootGetters["organization/organization"];
      if (organization.isActive) {
        return;
      }

      const canActivate = await axios
        .get(`/business/${organization.id}/activate`)
        .then(({ data }) => {
          context.commit("setBusinessProfile", data.isBusinessProfileConfigured);
          context.commit("setTaxRates", data.hasTaxRate);
          context.commit("setLocation", data.isLocationsSetup);
          context.commit("setSubscription", data.isSubscriptionActive);
          context.commit("setProductsAndPlans", data.isProductsAndPlansCreated);
          context.commit("setBrandColorsAndLogo", data.hasBrandColorsAndLogo);
          context.commit("setMerchantProcessing", data.isConnectWithStripe);
          return data.canActivate;
        })
        .catch(() => {
          return false;
        });

      if (canActivate) {
        await axios.put(`/business/${organization.id}/activate`).then(() => {
          context.dispatch("organization/activateOrganization", null, { root: true });
        });
      }
    },
  },
};
